<template>
  <div class="parent-box" v-show="Login">
    <div class="parent-shadow" @click="$emit('CloseLogin', false)"></div>
    <div class="parent animate__animated animate__fadeInRight">
      <div class="sign" v-show="boxType == 'sign'">
        <div class="from-head">
          <div class="login">
            <input type="radio" id="login" v-model="signType" value="login" hidden />
            <label for="login" @click="signTypeClick" :class="signType=='login'?'current': ''">登录</label>
          </div>
          <div class="resgiter">
            <input type="radio" id="resgiter" v-model="signType" value="resgiter" hidden />
            <label
              for="resgiter"
              @click="signTypeClick"
              :class="signType=='resgiter' ?'current':''"
            >注册</label>
          </div>
        </div>
        <!-- ____________登录______________ -->
        <div id="cm-login-from" v-show="signType=='login'">
          <div class="form-group tel-div m-t-47">
            <i class="mobile-icon"></i>
            <input
              type="text"
              id="login-mobile"
              name="mobile"
              placeholder="手机号"
              v-model="Params.mobile"
            />
            <label class="msg" id="login-mobile-error"></label>
          </div>
          <div class="form-group m-t-30 js-login-mi-div" v-show="changeSignType=='mi'">
            <i class="password-icon"></i>
            <input
              type="password"
              id="login-password"
              name="pass"
              placeholder="密码"
              v-model="Params.password"
            />
            <label class="msg" id="login-password-error"></label>
          </div>
          <div class="form-group capity-div m-t-30 js-login-yan-div" v-show="changeSignType=='yan'">
            <a class="btn-login-verify js-login-btn-verify">
              <button
                class="btn js-login-btn"
                type="button"
                :disabled="isable"
                @click="smsCode('login')"
              >发送验证码</button>
            </a>
            <i class="capity-icon"></i>
            <input
              type="text"
              id="login-capity"
              name="capity"
              placeholder="验证码"
              v-model="Params.code"
            />
            <label class="msg" id="login-capity-error"></label>
          </div>
          <div class="form-checkbox form-group m-t-30" v-show="changeSignType=='mi'">
            <input type="checkbox" id="login-checked" name="agree" checked />
            <label class="checked login-cecked" for="login-checked"></label>
            <a class="checked-text1">记住我</a>
            <a class="js-backpass checked-text2" @click="backPassword">忘记密码?</a>
          </div>
          <div class="form-change" :class="changeSignType=='mi' ? 'm-t-23' : 'm-t-80'">
            <div class="js-change-yan" v-show="changeSignType=='mi'">
              <input type="radio" id="change-yan" hidden v-model="changeSignType" value="yan" />
              <label for="change-yan" @click="signTypeClick">验证码登录</label>
            </div>
            <div class="js-change-mi" v-show="changeSignType=='yan'">
              <input type="radio" v-model="changeSignType" hidden id="change-mi" value="mi" />
              <label for="change-mi" @click="signTypeClick">密码登录</label>
            </div>
          </div>
          <button
            type="button"
            v-show="changeSignType=='mi'"
            class="cm-register-btn login-btn-div js-login-mi m-t-28"
            @click="login('mi')"
          >登录</button>
          <button
            type="button"
            class="cm-register-btn login-btn-div js-login-yan m-t-28"
            v-show="changeSignType=='yan'"
            @click="login('yan')"
          >登录</button>
          <div class="form-text resgiter-text m-t-50">
            <label>开启你的定制之旅！</label>
          </div>
          <div class="form-third-sign m-t-37">
            <p>第三方账号登录</p>
            <div class="btn-sign-icon m-t-22">
              <a @click="ToThird('wx')" class="weixin-icon"></a>
              <a @click="ToThird('weibo')" class="weibo-icon"></a>
              <a @click="ToThird('qq')" class="qq-icon"></a>
            </div>
          </div>
        </div>
        <!-- ___________注册_______________ -->
        <div id="cm-register-from" class="item" v-show="signType=='resgiter'">
          <div class="form-group tel-div m-t-47">
            <i class="mobile-icon"></i>
            <input
              type="text"
              id="register-mobile"
              name="mobile"
              placeholder="手机号"
              v-model="Params.mobile"
            />
            <label class="msg" id="register-mobile-error"></label>
          </div>
          <div class="form-group m-t-30">
            <i class="password-icon"></i>
            <input
              type="password"
              id="register-password"
              name="pass"
              placeholder="密码"
              v-model="Params.password"
            />
            <label class="msg" id="register-password-error"></label>
          </div>
          <div class="form-group capity-div m-t-30">
            <a class="btn-register-verify js-register-btn-verify">
              <button
                class="btn js-register-btn"
                type="button"
                :disabled="isable"
                @click="smsCode('register')"
              >发送验证码</button>
            </a>
            <i class="capity-icon"></i>
            <input
              type="text"
              id="register-capity"
              name="capity"
              placeholder="验证码"
              v-model="Params.code"
            />
            <label class="msg" id="register-capity-error"></label>
          </div>
          <div class="form-checkbox m-t-42">
            <input type="checkbox" id="register-checked" v-model="Params.check" name="agree" />
            <label class="checked resgiter-checked" for="register-checked"></label>
            我已阅读并接受
            <a class="common-color">用户协议</a>和
            <a class="common-color">隐私政策</a>
          </div>
          <button
            class="cm-register-btn resgiter-btn-div js-reigster m-t-28"
            :disabled="isable"
            @click="register"
          >注册</button>
          <div class="to-sign m-t-28">
            <label>
              已有账号，去
              <a class="common-color js-go-login" @click="Tologin">登录</a>
            </label>
          </div>
          <div class="form-text resgiter-text m-t-37">
            <label>开启你的定制之旅！</label>
          </div>
          <div class="form-third-sign m-t-28">
            <p>第三方账号登录</p>
            <div class="btn-sign-icon m-t-22">
              <a @click="ToThird('wx')" class="weixin-icon"></a>
              <a @click="ToThird('weibo')" class="weibo-icon"></a>
              <a @click="ToThird('qq')" class="qq-icon"></a>
            </div>
          </div>
        </div>
      </div>
      <!-- ____________忘记密码______________ -->
      <div class="backpass-div" v-show="boxType == 'back'">
        <div class="backpass-head" v-show="backType == 'backing'">
          <div class="js-backpass-text">找回密码</div>
        </div>
        <div id="cm-backpass-from" class="backpass" v-show="backType == 'backing'">
          <div class="form-group tel-div m-t-47">
            <i class="mobile-icon"></i>
            <input
              type="text"
              id="backpass-mobile"
              name="mobile"
              v-model="Params.mobile"
              placeholder="手机号"
            />
            <label class="msg" id="backpass-mobile-error"></label>
          </div>
          <div class="form-group m-t-30">
            <i class="password-icon"></i>
            <input
              type="password"
              id="set-password"
              name="pass"
              v-model="Params.password"
              placeholder="设置密码"
            />
            <label class="msg" id="set-password-error"></label>
          </div>
          <div class="form-group capity-div m-t-30">
            <a class="btn-backpass-verify js-backpass-btn-verify">
              <button
                class="btn js-backpass-btn"
                type="button"
                :disabled="isable"
                @click="smsCode('back')"
              >发送验证码</button>
            </a>
            <i class="capity-icon"></i>
            <input
              type="text"
              id="backpass-capity"
              name="capity"
              v-model="Params.code"
              placeholder="验证码"
            />
            <label class="msg" id="backpass-capity-error"></label>
          </div>
          <button
            type="button"
            class="cm-register-btn backpass-btn-div js-backpass-next m-t-28"
            @click="passwordReset"
          >确认修改</button>
        </div>
        <div class="reset-success-div" v-show="backType == 'backsuccess'">
          <div class="success-div"></div>
          <p class="m-t-54">您已成功修改密码，请使用新密码登录</p>
          <button type="button" class="cm-register-btn js-to-login m-t-36" @click="Tologin">去登录</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import qs from "qs";

export default {
  name: "header",
  data: function() {
    return {
      signType: "login",
      changeSignType: "mi",
      boxType: "sign",
      backType: "backing",
      Params: {
        mobile: "",
        password: "",
        code: "",
        check: true
      },
      isable: false,
      status: false
    };
  },
  props: {
    Login: Boolean,
    type: String
  },
  methods: {
    async smsCode(type) {
      if (type == "login") {
        if (this.Params.mobile == "") {
          return this.$message.error("手机号不能为空");
        }
        var reg = /^1[0-9]{10}$/;
        if (!reg.test(this.Params.mobile)) {
          return this.$message.error("手机号格式错误");
        }
        this.isable = true;
        const data = await this.$http.post(
          "/api/mobile/check",
          qs.stringify({
            mobile: this.Params.mobile
          })
        );
        if (data.data == true) {
          this.isable = false;
          this.$message.error("该手机未注册");
        } else {
          const res = await this.$http.post(
            "/api/send/smsCode",
            qs.stringify({
              mobile: this.Params.mobile
            })
          );
          if (res.code == 200) {
            this.isable = false;
            this.$message.success("验证码已发送");
            var num = 60;
            var timer = setInterval(function() {
              num--;
              $(".js-login-btn").text(num + "s");
              if (num == 0) {
                clearInterval(timer);
                $(".js-login-btn").html("获取验证码");
              }
            }, 1000);
          } else {
            this.isable = false;
            this.$message.error(res.msg);
          }
        }
      }
      if (type == "register") {
        if (this.Params.mobile == "") {
          return this.$message.error("手机号不能为空");
        }
        var reg = /^1[0-9]{10}$/;
        if (!reg.test(this.Params.mobile)) {
          return this.$message.error("手机号格式错误");
        }
        this.isable = true;
        const data = await this.$http.post(
          "/api/mobile/check",
          qs.stringify({
            mobile: this.Params.mobile
          })
        );
        if (data.data == false) {
          this.isable = false;
          this.$message.error("该手机已注册");
        } else {
          const res = await this.$http.post(
            "/api/send/smsCode",
            qs.stringify({
              mobile: this.Params.mobile,
              type: type
            })
          );
          if (res.code == 200) {
            this.isable = false;
            this.$message.success("验证码已发送");
            var num = 60;
            var timer = setInterval(function() {
              num--;
              $(".js-register-btn").text(num + "s");
              if (num == 0) {
                clearInterval(timer);
                $(".js-register-btn").html("获取验证码");
              }
            }, 1000);
          } else {
            this.isable = false;
            this.$message.error(res.msg);
          }
        }
      }
      if (type == "back") {
        if (this.Params.mobile == "") {
          return this.$message.error("手机号不能为空");
        }
        var reg = /^1[0-9]{10}$/;
        if (!reg.test(this.Params.mobile)) {
          return this.$message.error("手机号格式错误");
        }
        this.isable = true;
        const data = await this.$http.post(
          "/api/mobile/check",
          qs.stringify({
            mobile: this.Params.mobile
          })
        );
        if (data.data == true) {
          this.isable = false;
          this.$message.error("该手机未注册");
        } else {
          const res = await this.$http.post(
            "/api/send/smsCode",
            qs.stringify({
              mobile: this.Params.mobile
            })
          );
          if (res.code == 200) {
            this.isable = false;
            this.$message.success("验证码已发送");
            var num = 60;
            var timer = setInterval(function() {
              num--;
              $(".js-backpass-btn").text(num + "s");
              if (num == 0) {
                clearInterval(timer);
                $(".js-backpass-btn").html("获取验证码");
              }
            }, 1000);
          } else {
            this.isable = false;
            this.$message.error(res.msg);
          }
        }
      }
    },
    async register() {
      if (this.Params.mobile == "") {
        return this.$message.error("手机号不能为空");
      }
      var reg = /^1[0-9]{10}$/;
      if (!reg.test(this.Params.mobile)) {
        return this.$message.error("手机号格式错误");
      }
      if (this.Params.password == "") {
        return this.$message.error("密码不能为空");
      }
      if (this.Params.code == "") {
        return this.$message.error("验证码不能为空");
      }
      if (this.Params.check == false) {
        return this.$message.error("请勾选用户协议");
      }
      this.isable = true;
      const res = await this.$http.post(
        "/api/register",
        qs.stringify({
          account: this.Params.mobile,
          password: this.Params.password,
          code: this.Params.code
        })
      );
      if (res.code == 200) {
        this.isable = false;
        const datainfo = await this.$http.get("/api/userinfo");
        if (datainfo.data.mobile) {
          window.localStorage.setItem("uid", datainfo.data.uid);
          this.status = true;
        }
        var referer_url = localStorage.getItem("referer_url");
        if (referer_url) {
          localStorage.removeItem("referer_url");
          location.href = referer_url;
        }
        this.$emit("CloseLogin", false);
        this.$emit("LoginStatus", this.status);
        this.$message.success("注册成功");
        this.$emit("getinfo");
      } else {
        this.isable = false;
        this.$message.error(res.msg);
      }
    },
    async login(type) {
      if (type == "mi") {
        if (this.Params.mobile == "") {
          return this.$message.error("手机号不能为空");
        }
        var reg = /^1[0-9]{10}$/;
        if (!reg.test(this.Params.mobile)) {
          return this.$message.error("手机号格式错误");
        }
        if (this.Params.password == "") {
          return this.$message.error("密码不能为空");
        }
        this.isable = true;
        const res = await this.$http.post(
          "/api/mobile/check",
          qs.stringify({
            mobile: this.Params.mobile
          })
        );
        if (res.data == true) {
          this.isable = false;
          this.$message.error("该手机未注册");
        } else {
          const data = await this.$http.post(
            "/api/login",
            qs.stringify({
              account: this.Params.mobile,
              password: this.Params.password
            })
          );
          if (data.code == 200) {
            this.isable = false;
            const datainfo = await this.$http.get("/api/userinfo");
            if (datainfo.data.mobile) {
              window.localStorage.setItem("uid", datainfo.data.uid);
              this.status = true;
            }
            this.$emit("CloseLogin", false);
            this.$emit("LoginStatus", this.status);
            this.$message.success("登入成功");
            this.$emit("getinfo");
          } else {
            this.isable = false;
            this.$message.error(data.msg);
          }
        }
      }
      if (type == "yan") {
        if (this.Params.mobile == "") {
          return this.$message.error("手机号不能为空");
        }
        var reg = /^1[0-9]{10}$/;
        if (!reg.test(this.Params.mobile)) {
          return this.$message.error("手机号格式错误");
        }
        if (this.Params.code == "") {
          return this.$message.error("验证码不能为空");
        }
        this.isable = true;
        const res = await this.$http.post(
          "/api/mobile/check",
          qs.stringify({
            mobile: this.Params.mobile
          })
        );
        if (res.data == true) {
          this.isable = false;
          this.$message.error("该手机未注册");
        } else {
          const data = await this.$http.post(
            "/api/login",
            qs.stringify({
              mobile: this.Params.mobile,
              code: this.Params.code
            })
          );
          if (data.code == 200) {
            this.isable = false;
            const datainfo = await this.$http.get("/api/userinfo");
            if (datainfo.data.mobile) {
              window.localStorage.setItem("uid", datainfo.data.uid);
              this.status = true;
            }
            this.$emit("CloseLogin", false);
            this.$emit("LoginStatus", this.status);
            this.$message.success("登入成功");
            this.$emit("getinfo");
          } else {
            this.isable = false;
            this.$message.error(data.msg);
          }
        }
      }
    },
    async passwordReset() {
      const res = await this.$http.post(
        "/api/passwordreset",
        qs.stringify({
          account: this.Params.mobile,
          password: this.Params.password,
          code: this.Params.code
        })
      );
      if (res.code == 200) {
        this.Params.mobile = "";
        this.Params.password = "";
        this.Params.code = "";
        this.backType = "backsuccess";
      } else {
        this.$message.error(res.msg);
      }
    },
    backPassword() {
      this.Params.mobile = "";
      this.Params.password = "";
      this.Params.code = "";
      this.boxType = "back";
    },
    signTypeClick() {
      this.Params.mobile = "";
      this.Params.password = "";
      this.Params.code = "";
      this.changeSignType = "mi";
    },
    Tologin() {
      this.Params.mobile = "";
      this.Params.password = "";
      this.Params.code = "";
      this.signType = "login";
      this.changeSignType = "mi";
      this.boxType = "sign";
    },
    ToThird(type) {
      window.location.href = "/api/oauth?type=" + type;
    }
  },
  watch: {
    Login: function(newValue, oldValue) {
      this.Login = newValue;
      if (newValue) {
        this.Params.mobile = "";
        this.Params.password = "";
        this.Params.code = "";
        this.signType = "login";
        this.changeSignType = "mi";
        this.boxType = "sign";
      }
    },
    type: function(newValue, oldValue) {
      if (newValue) {
        this.signType = newValue;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      var _this = this;
      $(document).keyup(function(event) {
        if ($(".parent-box").css("display") == "block") {
          if (event.keyCode == 13) {
            if (_this.signType == "login") {
              if (_this.changeSignType == "mi") {
                _this.login("mi");
              } else {
                _this.login("yan");
              }
            } else {
              _this.register();
            }
          }
        }
      });
    });
  },
  created() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/css/base/button.scss";
.parent-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1111;
  overflow: hidden;
  .parent-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(74, 74, 74, 1);
    opacity: 0.5;
    overflow: hidden;
  }
  .current {
    color: $button-6E63E8-color !important;
  }
  input::-webkit-input-placeholder {
    color: rgba(153, 153, 153, 1);
  }
  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: rgba(153, 153, 153, 1);
  }
  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: rgba(153, 153, 153, 1);
  }
  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: rgba(153, 153, 153, 1);
  }
  .parent {
    width: 616px;
    height: 100%;
    min-height: 890px;
    background: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    position: absolute;
    top: 0;
    right: 0;
  }
  #cm-register-from {
    width: 392px;
    margin: 0 auto;
    text-align: center;
  }
  #cm-login-from {
    width: 392px;
    margin: 0 auto;
    text-align: center;
  }
  .from-head {
    display: flex;
    width: 392px;
    box-sizing: border-box;
    margin: 105px auto 0;
    padding: 0 85px 0 74px;
    .login {
      margin-right: 145px;
    }
    label {
      font-size: 22px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 30px;
      cursor: pointer;
    }
  }
  .form-group {
    position: relative;
    width: 392px;
    height: 50px;
  }
  .form-group input {
    box-sizing: border-box;
    width: 392px;
    height: 50px;
    border: 1px solid rgba(151, 151, 151, 1);
    outline: none;
    padding-left: 66px;
    font-size: 18px;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
    font-weight: 400;
    color: $button-6E63E8-color;
    line-height: 25px;
  }
  .form-group .msg {
    position: absolute;
    bottom: -27px;
    left: 4px;
    color: red;
  }
  .form-group i {
    display: block;
    position: absolute;
    top: 15px;
    left: 25px;
  }
  .mobile-icon {
    width: 22px;
    height: 24px;
    background: url(../assets/img/tel-icon.png) no-repeat;
    background-size: 17px 24px;
  }
  .password-icon {
    display: inline-block;
    width: 22px;
    height: 21px;
    background: url(../assets/img/pass-icon.png) no-repeat;
    background-size: 17px 21px;
  }
  .capity-icon {
    display: inline-block;
    width: 22px;
    height: 20px;
    background: url(../assets/img/capity-icon.png) no-repeat;
    background-size: 17px 20px;
  }
  .form-group /deep/ .btn {
    position: absolute;
    top: 14px;
    right: 13px;
    border: 0;
    outline-style: none;
    background-color: #fff;
    font-size: 18px;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
    font-weight: 400;
    color: $button-6E63E8-color;
    line-height: 25px;
    cursor: pointer;
    outline: 0;
    z-index: 99;
  }
  .form-checkbox {
    position: relative;
  }
  .form-checkbox input {
    width: 20px;
    height: 20px;
    visibility: hidden;
  }
  .form-checkbox label {
    width: 20px;
    height: 20px;
    border: 1px solid #666666;
    font-size: 18px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #666666;
    line-height: 27px;
  }
  .resgiter-checked {
    position: absolute;
    left: 43px;
    top: 6px;
  }
  .login-cecked {
    position: absolute;
    left: 5px;
    top: 6px;
  }
  .form-checkbox .checked-text1 {
    position: absolute;
    left: 59px;
    top: 4px;
    font-size: 18px;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 25px;
  }
  .form-checkbox .checked-text2 {
    position: absolute;
    right: 0;
    top: 4px;
    font-size: 18px;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 25px;
    cursor: pointer;
  }
  .form-change {
    font-size: 18px;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 25px;
    label {
      cursor: pointer;
    }
  }
  .common-color {
    color: $button-6E63E8-color;
    cursor: pointer;
  }
  .form-checkbox [type="checkbox"]:checked + .checked {
    background: $button-6E63E8-color url(../assets/img/success.png) no-repeat
      center center;
    background-size: 16px 13px;
  }
  .checked {
    background: none;
  }
  .cm-register-btn {
    width: 392px;
    height: 60px;
    background: $button-6E63E8-color;
    box-sizing: border-box;
    border: none;
    outline: none;
    font-size: 20px;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 27px;
    cursor: pointer;
  }
  .to-sign label {
    font-size: 18px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 27px;
  }
  .form-text {
    font-size: 22px;
    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
  }
  .form-third-sign p {
    font-size: 20px;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 27px;
    margin: 0;
  }
  .btn-sign-icon a {
    display: inline-block;
    cursor: pointer;
  }
  .btn-sign-icon .weixin-icon {
    width: 30px;
    height: 25px;
    background: url(../assets/img/weixin-icon-index.png) no-repeat;
    background-size: 30px 25px;
  }
  .btn-sign-icon .weibo-icon {
    width: 30px;
    height: 24px;
    background: url(../assets/img/weibo-icon.png) no-repeat;
    margin: 0 36px;
    background-size: 30px 24px;
  }
  .btn-sign-icon .qq-icon {
    width: 27px;
    height: 27px;
    background: url(../assets/img/qq-icon.png) no-repeat;
    background-size: 27px 27px;
  }
  .btn-sign-icon .weixin-icon:hover {
    background-size: 30px 25px !important;
    background: url(../assets/img/weixin-hover.png) no-repeat !important;
  }
  .btn-sign-icon .weibo-icon:hover {
    background-size: 30px 24px !important;
    background: url(../assets/img/weibo-hover.png) no-repeat !important;
  }
  .btn-sign-icon .qq-icon:hover {
    background: url(../assets/img/qq-hover.png) no-repeat !important;
    background-size: 27px 27px !important;
  }
  // .parent {
  //   width: 392px;
  //   position: absolute;
  //   top: 50%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);
  //   box-sizing: border-box;
  //   height: 100%;
  //   padding-top: 102px;
  // }
  // .parent-height {
  //   height: 100%;
  // }
  // 找回密码
  .backpass-div {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 105px 120px 0 105px;
  }

  .backpass-head div {
    font-size: 22px;
    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
    text-align: center;
  }

  // 密码重置成功
  .reset-success-div {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    text-align: center;
    .success-div {
      width: 150px;
      height: 150px;
      margin: 0 auto;
      border-radius: 50%;
      background: $button-6E63E8-color url(../assets/img/success.png) no-repeat
        center center;
      background-size: 68px 47px;
    }
    p {
      font-size: 20px;
      font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 27px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/lgoinbox.vue